<div class="fixed inset-0 z-[50] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in overflow-y-auto"
    (click)="closeModal()">

    <!-- Premium Modal Container (Glassmorphic) -->
    <div class="bg-white dark:bg-slate-800 w-full max-w-5xl max-h-[90vh] rounded-[2.5rem] shadow-2xl  flex flex-col relative animate-fade-in-up z-[100]"
        (click)=" $event.stopPropagation(); openDropdown=null">

        <!-- Main Header (Standard Project Style) -->
        <div
            class="px-8 py-6 border-b border-slate-100 dark:border-slate-700 flex items-center justify-between bg-white rounded-t-[2.5rem]  dark:bg-slate-800 z-10 sticky top-0">
            <div class="flex items-center gap-4">
                <div class="w-12 h-12 rounded-2xl bg-amber-50 dark:bg-amber-900/30 flex items-center justify-center">
                    <span class="material-icons text-amber-500 text-2xl">groups</span>
                </div>
                <div>
                    <h2 class="text-xl font-black text-slate-800 dark:text-slate-100 tracking-tight">
                        {{ data ? 'แก้ไขกลุ่มจุดให้บริการ' : 'เพิ่มกลุ่มจุดให้บริการ' }}
                    </h2>
                    <p
                        class="text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-[0.2em] mt-0.5">
                        Provider Group / {{ data ? 'Edit' : 'New' }}
                    </p>
                </div>
            </div>

            <div class="flex items-center gap-3">
                <button (click)="closeModal()"
                    class="px-6 py-2.5 rounded-xl text-slate-500 dark:text-slate-400 font-bold hover:bg-slate-50 dark:hover:bg-slate-700 transition-all active:scale-95 cursor-pointer">
                    ยกเลิก
                </button>
                <button (click)="onSave()" [disabled]="isLoading"
                    class="px-8 py-2.5 bg-amber-400 dark:bg-amber-500 hover:bg-amber-500 dark:hover:bg-amber-600 disabled:opacity-50 text-white font-black rounded-xl shadow-lg shadow-amber-200 dark:shadow-none hover:-translate-y-0.5 transition-all active:scale-95 flex items-center gap-2 cursor-pointer">
                    <span *ngIf="isLoading"
                        class="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
                    <span class="material-icons text-lg" *ngIf="!isLoading">save</span>
                    บันทึกข้อมูล
                </button>
            </div>
        </div>

        <!-- Form Area (HORIZONTAL LAYOUT PER SCREENSHOT) -->
        <div class="flex-1 p-12 pb-[50px] relative custom-scrollbar">
            <div
                class="bg-white dark:bg-slate-800/50 rounded-[2rem] border border-slate-50 dark:border-slate-700 p-10 shadow-sm relative z-[10]">

                <!-- Subtle Decoration -->
                <div class="absolute -top-10 -right-10 w-40 h-40 bg-amber-400/5 rounded-full blur-3xl"></div>

                <div class="grid grid-cols-1 lg:grid-cols-2 gap-x-16 gap-y-10 relative z-10">

                    <!-- LEFT COLUMN (Horizontal Mapping) -->
                    <div class="space-y-10">
                        <!-- ID Row -->
                        <div class="grid grid-cols-[180px,1fr] items-center">
                            <label
                                class="text-[11px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest px-1">ไอดี
                                (ID)</label>
                            <div
                                class="px-4 py-2 border-b border-slate-100 dark:border-slate-700/50 text-slate-300 dark:text-slate-600 font-mono text-sm italic min-h-[44px] flex items-center">
                                {{ data ? form.id : '(AUTO)' }}
                            </div>
                        </div>

                        <!-- Name Row -->
                        <div class="grid grid-cols-[180px,1fr] items-center group">
                            <label
                                class="text-[11px] font-black text-slate-500 dark:text-slate-400 uppercase tracking-widest px-1 group-focus-within:text-amber-500 transition-colors">ชื่อกลุ่มจุดให้บริการ</label>
                            <div class="relative">
                                <span
                                    class="absolute left-4 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[18px]">label_important</span>
                                <input type="text" [(ngModel)]="form.name" placeholder="ระบุชื่อกลุ่มจุดให้บริการ..."
                                    class="w-full h-11 pl-12 pr-4 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-2xl text-slate-700 dark:text-slate-200 font-bold text-sm focus:bg-white dark:focus:bg-slate-800 focus:ring-4 focus:ring-amber-100 dark:focus:ring-amber-500/10 focus:border-amber-400 transition-all outline-none">
                            </div>
                        </div>

                        <!-- Service Points Row -->
                        <div class="grid grid-cols-[180px,1fr] items-start group relative z-[100]">
                            <label
                                class="text-[11px] font-black text-slate-500 dark:text-slate-400 uppercase tracking-widest px-1 mt-3 group-focus-within:text-amber-500 transition-colors">จุดให้บริการ</label>
                            <div class="space-y-4 relative w-full z-[120] relative z-[150]">
                                <!-- Beautiful Custom Dropdown Selector -->
                                <div (click)="toggleDropdown('point', $event)"
                                    class="w-full h-11 px-5 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-2xl flex items-center justify-between cursor-pointer hover:border-amber-200 transition-all"
                                    [class.ring-4]="openDropdown === 'point'"
                                    [class.ring-amber-100]="openDropdown === 'point'">
                                    <span class="text-slate-400 text-sm italic font-bold">เลือกจุดให้บริการ...</span>
                                    <span class="material-icons text-slate-400 text-[22px] transition-transform"
                                        [class.rotate-180]="openDropdown === 'point'">expand_more</span>
                                </div>

                                <!-- Tags List -->
                                <div class="flex flex-wrap gap-2 pt-1">
                                    <div *ngFor="let p of form.servicePoints; let idx = index"
                                        class="px-3.5 py-1.5 bg-white dark:bg-slate-800 border-2 border-slate-50 dark:border-slate-700 rounded-2xl shadow-sm text-[11px] font-black text-slate-600 dark:text-slate-300 flex items-center gap-2 hover:border-amber-200 hover:scale-105 transition-all">
                                        {{ p }}
                                        <button (click)="removePoint(idx)" class="text-slate-300 hover:text-rose-500">
                                            <span class="material-icons text-[16px]">cancel</span>
                                        </button>
                                    </div>
                                    <div *ngIf="form.servicePoints.length === 0"
                                        class="py-4 text-center w-full text-slate-300 text-xs italic font-bold">
                                        ยังไม่ระบุจุดให้บริการ...
                                    </div>
                                </div>

                                <!-- Dropdown Overlay -->
                                <div *ngIf="openDropdown === 'point'"
                                    class="absolute z-[150] top-12 left-0 right-0 mt-1 bg-white/95 dark:bg-slate-800/95 backdrop-blur-xl border border-slate-100 dark:border-slate-700 shadow-dropdown rounded-3xl max-h-[250px] overflow-y-auto custom-scrollbar animate-fade-in-up">
                                    <div *ngFor="let item of pointList.data" (click)="selectPoint(item)"
                                        class="p-4 hover:bg-amber-50 dark:hover:bg-amber-900/20 cursor-pointer text-sm font-black text-slate-700 dark:text-slate-300 transition-all border-b border-slate-50 dark:border-slate-700/50 last:border-none flex items-center justify-between">
                                        <span>{{ item.name }}</span>
                                        <span *ngIf="form.servicePoints.includes(item.name)"
                                            class="material-icons text-amber-500">check_circle</span>
                                    </div>

                                    <!-- See More Button -->
                                    <div *ngIf="pointList.more" (click)="onSeeMore('point', $event)"
                                        class="p-3 bg-slate-50 dark:bg-slate-900/50 text-center hover:bg-amber-50 dark:hover:bg-amber-900/20 cursor-pointer group transition-all sticky bottom-0">
                                        <p
                                            class="text-[10px] font-black text-slate-400 group-hover:text-amber-500 uppercase tracking-widest flex items-center justify-center gap-1">
                                            ขยายรายละเอียด <span class="material-icons text-sm">open_in_new</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- RIGHT COLUMN -->
                    <div class="space-y-10 lg:border-l lg:border-slate-100/50 lg:pl-16">
                        <!-- Site Row -->
                        <div class="grid grid-cols-[140px,1fr] items-center group">
                            <label
                                class="text-[11px] font-black text-slate-500 dark:text-slate-400 uppercase tracking-widest px-1 group-focus-within:text-amber-500 transition-colors">ไซด์
                                (SITE)</label>
                            <div class="relative w-full">
                                <button type="button" (click)="toggleDropdown('site', $event)"
                                    class="w-full h-11 px-5 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-2xl flex items-center justify-between cursor-pointer hover:border-amber-200 transition-all outline-none"
                                    [class.ring-4]="openDropdown === 'site'"
                                    [class.ring-amber-100]="openDropdown === 'site'">
                                    <div class="flex items-center gap-3 overflow-hidden">
                                        <span class="material-icons text-slate-400 text-[18px]">near_me</span>
                                        <span
                                            [ngClass]="!form.site ? 'text-slate-400 font-normal italic' : 'text-slate-800 dark:text-slate-100 font-bold'">
                                            {{ form.site || 'เลือกพื้นที่ให้บริการ' }}
                                        </span>
                                    </div>
                                    <span class="material-icons text-slate-400 transition-transform"
                                        [class.rotate-180]="openDropdown === 'site'">expand_more</span>
                                </button>

                                <!-- Dropdown Overlay -->
                                <div *ngIf="openDropdown === 'site'"
                                    class="absolute z-[150] top-full left-0 right-0 mt-2 bg-white/95 dark:bg-slate-800/95 backdrop-blur-xl border border-slate-100 dark:border-slate-700 shadow-dropdown rounded-3xl max-h-[250px] overflow-y-auto custom-scrollbar animate-fade-in-up">
                                    <div *ngFor="let item of siteList?.data" (click)="selectSite(item)"
                                        class="p-4 hover:bg-amber-50 dark:hover:bg-amber-900/20 cursor-pointer text-sm font-black text-slate-700 dark:text-slate-300 transition-all border-b border-slate-50 dark:border-slate-700/50 last:border-none">
                                        {{ item.name }}
                                    </div>

                                    <!-- See More Button -->
                                    <div *ngIf="siteList?.more" (click)="onSeeMore('site', $event)"
                                        class="p-3 bg-slate-50 dark:bg-slate-900/50 text-center hover:bg-amber-50 dark:hover:bg-amber-900/20 cursor-pointer group transition-all sticky bottom-0">
                                        <p
                                            class="text-[10px] font-black text-slate-400 group-hover:text-amber-500 uppercase tracking-widest flex items-center justify-center gap-1">
                                            ขยายรายละเอียด <span class="material-icons text-sm">open_in_new</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Extra Footer Area -->
        <!-- <div class="px-8 py-4 bg-slate-50/50 dark:bg-slate-900/30 border-t border-slate-100 dark:border-slate-700">
            <p class="text-[9px] font-bold text-slate-400 uppercase tracking-widest text-center">
                PSS Group / Provider Group Management System Component
            </p>
        </div> -->
    </div>
</div>